<script>
  import Help from "../help.svelte";
  </script>

  <Help helpId={"Help14"} showSearchOption={false} back="/about"/>